import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

export type {
    ExtensionSettings, ExtensionSettingsBooleans, ExtensionSettingsFieldKey
} from "app/pages/sales-intelligence/modules/extension-management/types";

export const ExportIntegrations: Record<CrmIntegrationProvider, CrmIntegrationProvider> = Object.seal({
    salesforce: "salesforce",
    hubspot: "hubspot",
    dynamics: "dynamics",
});